import { UNDEFINED_SUPPORT_ID } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitTimeKeeping/constants';
import {
  TimeKeepingRecords,
  TimeKeepingSupportRegistry,
} from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitTimeKeeping/types';
import { TClipLogo } from '@/features/clips/types';
import { EVisibility } from '@/types/types';

export const buildSupportsFromLogos = (entries: TClipLogo[]): TimeKeepingSupportRegistry[] => {
  const bySupport = new Map<string, TimeKeepingRecords[]>();
  for (const entry of entries) {
    const supportId = entry.parameters?.support_id ?? entry.support ?? UNDEFINED_SUPPORT_ID;
    if (!bySupport.has(supportId)) bySupport.set(supportId, []);
    bySupport.get(supportId)!.push({
      id: entry.id,
      visibility: entry.parameters?.visibility ?? EVisibility.MEDIA,
      datetimeStart: entry.start_datetime,
      datetimeEnd: entry.end_datetime,
    });
  }
  return Array.from(bySupport.entries()).map(([presenceId, records]) => ({ presenceId, records }));
};
